import React from "react";
import SprinkledStars from "@herb/components/SprinkledStars";

const AdventCalendarHero = ({ titleImage, subtitleText, features }) => {
 
  return (
    <div className="advc-hero">
      <img
        className="advc-hero-image"
        src={titleImage?.sourceUrl}
        alt={titleImage?.altText}
      />
      <p className="advc-hero-text"> <pre>{subtitleText || ""}</pre></p>
      <ul className="advc-features">
        {features?.map((feature, index) => (
          <li key={index} className="advc-feature advc-feature-little">
            <svg
            className="advc-feature-little-icon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.9177 3.66864C18.7122 5.46309 19.6094 7.63401 19.6094 10.1814C19.6094 12.7288 18.7122 14.8998 16.9177 16.6942C15.1233 18.4886 12.9523 19.3859 10.4049 19.3859C7.85752 19.3859 5.6866 18.4886 3.89215 16.6942C2.09947 14.8998 1.20312 12.7288 1.20312 10.1814C1.20312 7.63401 2.09947 5.46309 3.89215 3.66864C5.6866 1.87596 7.85752 0.979614 10.4049 0.979614C12.9523 0.979614 15.1233 1.87596 16.9177 3.66864ZM9.32826 15.0423L16.1577 8.21545C16.4533 7.94276 16.4533 7.67008 16.1577 7.39739L15.3397 6.54503C15.0441 6.27235 14.76 6.27235 14.4873 6.54503L8.92188 12.1104L6.32257 9.51378C6.04988 9.2411 5.76576 9.2411 5.47021 9.51378L4.65215 10.3661C4.3566 10.6388 4.3566 10.9115 4.65215 11.1842L8.51285 15.0423C8.78553 15.3396 9.05734 15.3396 9.32826 15.0423Z"
                fill="#DEF89B"
              />
            </svg>
            <span>
            {feature.features.split(" ").map((word, index) => {
              if (word.toLowerCase() === "free") {
                return (
                  <span key={index} className="advc-feature-bold">
                    {word + " "}
                  </span>
                );
              } else {
                return word + " ";
              }
            })}
            </span>
          </li>
        ))}
      </ul>
      <SprinkledStars />
    </div>
  );
};

export default AdventCalendarHero;
